/**
 * MafiaGameOver — Game over screen with all roles revealed
 *
 * Requirements: 11.5, 11.6, 23.4
 */

import React from 'react';
import { MafiaGameResult, ROLE_INFO } from '../types';
import './MafiaGameOver.css';

export interface MafiaGameOverProps {
  result: MafiaGameResult;
  onPlayAgain: () => void;
  onExit: () => void;
}

export const MafiaGameOver: React.FC<MafiaGameOverProps> = ({
  result,
  onPlayAgain,
  onExit,
}) => {
  const isVillageWin = result.winner === 'village';

  return (
    <div className="mafia-game-over" role="alert" aria-label="Game Over">
      <div className="mafia-game-over__icon">
        {isVillageWin ? '🏘️' : '🔪'}
      </div>

      <h2
        className={`mafia-game-over__title ${
          isVillageWin ? 'mafia-game-over__title--village' : 'mafia-game-over__title--mafia'
        }`}
      >
        {isVillageWin ? 'Village Wins!' : 'Mafia Wins!'}
      </h2>

      <p className="mafia-game-over__reason">{result.winReason}</p>

      <div className="mafia-game-over__players">
        <h3>All Players & Roles</h3>
        <ul className="mafia-game-over__player-list">
          {result.players.map((player) => {
            const roleInfo = ROLE_INFO[player.role];
            return (
              <li key={player.id} className="mafia-game-over__player-item">
                <span
                  className={`mafia-game-over__player-name ${
                    !player.survived ? 'mafia-game-over__player-name--dead' : ''
                  }`}
                >
                  {player.name} {!player.survived ? '👻' : ''}
                </span>
                <span className="mafia-game-over__player-role">
                  {roleInfo.icon} {roleInfo.name}
                </span>
              </li>
            );
          })}
        </ul>
      </div>

      <div className="mafia-game-over__stats">
        Total Cycles: {result.totalCycles}
      </div>

      <div className="mafia-game-over__actions">
        <button
          className="mafia-game-over__btn mafia-game-over__btn--primary"
          onClick={onPlayAgain}
          aria-label="Play again"
        >
          🎮 Play Again
        </button>
        <button
          className="mafia-game-over__btn"
          onClick={onExit}
          aria-label="Return to Game Hub"
        >
          ← Back to Game Hub
        </button>
      </div>
    </div>
  );
};

export default MafiaGameOver;
